export default {
      id: "oc-aliyun-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-aliyun",
      toString: function () {
        return this.url;
      }
    }